var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('app-main',{staticClass:"app-main"}),_c('navigation-bar',{staticClass:"navigation-bar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }